import PropTypes from 'prop-types';
import { useTheme } from '@emotion/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { vmPropTypes } from '../../global-prop-types';
import ComponentsArrRenderer from '../core/ComponentsArrRenderer';
import { useSettingsWithManage } from '../../modules/manage-config';
import { syncJmtSettings } from '../../global-utils/vmFunctions/myNetworking/settings';

const JMTMembershipApplication = (props) => {
  const { primaryColor, ...restProps } = props;
  const navigate = useNavigate();
  const moduleSettings = useSettingsWithManage(
    'jmtMembershipApplicationModule'
  );

  const theme = useTheme();
  const [isMembershipApplicationDone, setIsMembershipApplicationDone] = useState(false);

  useEffect(() => {
    const handleDone = () => {
      setIsMembershipApplicationDone(true);
      syncJmtSettings({ skipDebounce: true });
    };

    window.addEventListener(
      'm-anage.com.component.membership-application.done',
      handleDone
    );

    return () => {
      window.removeEventListener(
        'm-anage.com.component.membership-application.done',
        handleDone
      );
    };
  }, []);

  if (!moduleSettings) return 'Cannot get settings and render';

  const {
    language, short, context, apiBaseUrl, accessToken, membershipDoneUrl
  } = moduleSettings;
  if (!accessToken) return 'User not logged';

  if (isMembershipApplicationDone && membershipDoneUrl) {
    navigate(membershipDoneUrl);
  }

  if (isMembershipApplicationDone) {
    return <ComponentsArrRenderer {...restProps} />;
  }

  return (
    <div>
      <style>
        {/* This component expects css var --primaryColor */}
        {`[id="m-anage.com.component.membership-application"] {
          --primaryColor: ${primaryColor || 'var(--vm-primary-color-1)'};
        }`}
      </style>
      <div
        id="m-anage.com.component.membership-application"
        context={context}
        language={language}
        theme={JSON.stringify(theme)}
        accesstoken={accessToken}
        societyshort={short}
        apiurl={apiBaseUrl}
      />
    </div>
  );
};

JMTMembershipApplication.propTypes = {
  primaryColor: PropTypes.string
};
JMTMembershipApplication.defaultProps = {};
JMTMembershipApplication.vmPropTypes = {
  components: vmPropTypes.components,
  primaryColor: vmPropTypes.string
};

export default JMTMembershipApplication;
